
import productpackageapis from "./devapis/productpackage";

export const devapis = {
  ...productpackageapis,
  login: {
    url: "/api/v1/auth/login",
    method: "post",
  },
  refreshToken: {
    url: "/api/v1/auth/refresh",
    method: "post",
  },
  forgetpassword: {
    url: "/api/v1/auth/forget",
    method: "post",
  },
  changepassword: {
    url: "/api/v1/auth/password",
    method: "put",
  },

  getDashboard: {
    url: "/api/v2/dashboard/?school_id={school_id}",
    method: "get",
  },
  userSignup: {
    url: "/api/v2/b2c/auth/signup",
    method: "post",
  },
  customerLogin: {
    url: "/api/v2/b2c/auth/login",
    method: "post",
  },
  customerForgetPassword: {
    url: "/api/v2/b2c/auth/password/reset",
    method: "post",
  },
  customerChangePassword: {
    url: "/api/v2/b2c/auth/password/change",
    method: "put",
  },
  generateOtp: {
    url: "/api/v2/b2c/auth/generate/mobileotp",
    method: "post",
  },
  otpLoginVerify: {
    url: "/api/v2/b2c/auth/verifyotp",
    method: "post",
  },
  otpLogin: {
    url: "/api/v2/b2c/auth/otp/login",
    method: "post",
  },
  getB2cUser: {
    url: "/api/v2/b2c/auth",
    method: "get",
  },
  updateB2cUser: {
    url: "/api/v2/b2c/auth",
    method: "put",
  },
  downloadFile: {
    url: `/api/v1/download-documents`,
    method: "post",
  },
  // PROFILES
  createProfile: {
    url: "/api/v1/profile",
    method: "post",
  },
  getProfile: {
    url: "/api/v1/profile",
    method: "get",
  },
  getUser: {
    url: "/api/v1/profile/me",
    method: "get",
  },
  getProfileById: {
    url: "/api/v1/profile/{profile_id}",
    method: "get",
  },
  updateProfileById: {
    url: "/api/v1/profile/{profile_id}",
    method: "put",
  },
  deleteProfile: {
    url: "/api/v1/profile/{profile_id}",
    method: "delete",
  },
};

export default devapis;